// Vendor
import * as React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

// Internal
import { Image } from '@src/components/Image';
import { DEFAULT_SAL_PROPS } from '@src/config/sal';

// Styles
import styles from './styles.module.css';

const getCelebrityEvents = graphql`
  query getCelebrityEvents {
    allCelebrityEventsJson {
      nodes {
        description
        month
        image {
          alt
          fileName
        }
      }
    }
  }
`;

const StigmaToStatus: React.FC = () => {
  // Hooks
  const data = useStaticQuery(getCelebrityEvents);

  // Setup
  const items = data.allCelebrityEventsJson.nodes;

  // Markup
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderItem =
    (mobile = false) =>
    // eslint-disable-next-line react/display-name
    (item: any, index: number) => {
      const { description, image, month } = item;
      const alt = image?.alt || '';
      const fileName = image?.fileName || '';
      const delay = index * 50;
      const animationProps = mobile
        ? {}
        : { ...DEFAULT_SAL_PROPS, 'data-sal-delay': delay };

      return (
        <div {...animationProps} className="" key={month}>
          <h3 className="text-center bg-cleanout-lighter text-sm tracking-wider uppercase font-bold p-4">
            {month}
          </h3>
          <Image alt={alt} fileName={fileName} />
          <p
            className="p-4 pt-4"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
      );
    };

  return (
    <div className="tup-slide">
      <h1 {...DEFAULT_SAL_PROPS}>
        Stigma to Status:
        <br />
        Celebrities Champion Secondhand
      </h1>
      <div className={styles.calendar}>{items.map(renderItem())}</div>
      <div className={styles.calendarMobile}>{items.map(renderItem(true))}</div>
    </div>
  );
};

export { StigmaToStatus };
